module.exports = __webpack_public_path__ + "img/home.0997611b.svg";